import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  ProposalSlideOver,
  ProposalSlideOverContent,
  ProposalSlideOverContentSkeleton,
  ProposalSlideOverNotFound,
} from "~/routes/(restricted)/byggeradar/-components/ProposalSlideOver";
import { useProposal } from "~/routes/(restricted)/byggeradar/-hooks/useProposal";
import { proposalSearchSchema } from "~/routes/(restricted)/byggeradar/-schemas/proposal-search";

export const Route = createFileRoute(
  "/(restricted)/byggeradar/_access/agent/$agentId/$proposalId",
)({
  component: RouteComponent,
  validateSearch: proposalSearchSchema,
  beforeLoad: async ({
    params: { proposalId },
    context: { preloadedAgent },
  }) => {
    if (!preloadedAgent) {
      // If we do not find a saved agent for the user, we redirect to the proposal, outside the agent context.
      // This could occur if the user bookmarks the url & deletes the agent, or if someone sends the agent-specific url to someone.
      throw redirect({
        to: "/byggeradar/search/$proposalId",
        params: { proposalId },
        search: (current) => current,
        replace: true,
        viewTransition: false,
      });
    }

    return { preloadedAgent };
  },
  notFoundComponent: ProposalSlideOverNotFound,
});

function RouteComponent() {
  const { proposalId } = Route.useParams();
  const { isLoading, proposal, error } = useProposal(proposalId);

  return (
    <ProposalSlideOver>
      {error ? (
        <ProposalSlideOverNotFound />
      ) : !isLoading && proposal ? (
        <ProposalSlideOverContent
          proposalId={proposalId}
          proposal={proposal}
        />
      ) : (
        <ProposalSlideOverContentSkeleton />
      )}
    </ProposalSlideOver>
  );
}
